class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.productUrl = null;
  }

  connectedCallback() {
    this.productUrl = this.dataset.productUrl;

    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick(event) {
    const target = event.target instanceof Element ? event.target : null;

    // Aperçu rapide (quickview) : TOUT le groupe (image, titre, "en savoir plus"...) ouvre la modale,
    // sans aucune friction qui renverrait vers la page produit (on bloque le lien groupe).
    if (this.dataset.quickview === 'true') {
      // Ne pas intercepter les clics dans la modale/machinerie quickview (laisser le dialog fonctionner).
      if (target && target.closest('.product-card__quickview')) return;

      event.preventDefault();
      const toggle = this.querySelector('.product-card__quickview [data-ref="popup-toggle"]');
      if (toggle) {
        toggle.click();
        return;
      }
      window.location.href = this.productUrl;
      return;
    }

    // Comportement d'origine (quickview désactivé) : ne pas capter les éléments interactifs.
    if (target) {
      const interactiveElement = target.closest(
        'button, input, label, select, [tabindex="1"], a, quick-add-component, add-to-wishlist-button',
      );
      if (interactiveElement) return;
    }

    window.location.href = this.productUrl;
  }
}

if (!customElements.get('product-card')) {
  customElements.define('product-card', ProductCard);
}
